/**
 * Standardized typography and styling for consistent UI across the application
 * 
 * Usage:
 * import { typography } from '../theme/typography';
 * 
 * // In your component:
 * <Typography sx={typography.h1}>Title</Typography>
 * <Typography sx={typography.body}>Regular text</Typography>
 */

export const typography = {
  // Headers
  h1: {
    fontSize: '1.8rem',
    fontWeight: 700,
    lineHeight: 1.2,
    mb: 2,
  },
  h2: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.3,
    mb: 1.5,
  },
  h3: {
    fontSize: '1.2rem',
    fontWeight: 600,
    lineHeight: 1.4,
    mb: 1,
  },
  
  // Body text
  body: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  bodyBold: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  bodySmall: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  
  // Table cells
  tableHeader: {
    fontSize: '0.875rem',
    fontWeight: 600,
    textTransform: 'none',
    letterSpacing: '0.5px',
    color: 'text.secondary',
  },
  tableCell: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  tableCellBold: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  
  // Labels and badges
  label: {
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    lineHeight: 1.2,
  },
  
  // Numbers and values
  number: {
    fontSize: '1rem',
    fontWeight: 600,
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1,
  },
  numberLarge: {
    fontSize: '1.2rem',
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1,
  },
};

// Common cell styles
export const cellStyles = {
  base: {
    py: 1.5,
    px: 2,
    verticalAlign: 'middle',
  },
  center: {
    textAlign: 'center',
    justifyContent: 'center',
  },
  left: {
    textAlign: 'left',
    justifyContent: 'flex-start',
  },
  right: {
    textAlign: 'right',
    justifyContent: 'flex-end',
  },
  header: {
    ...typography.tableHeader,
    py: 1.5,
    px: 2,
    borderBottom: 1,
    borderColor: 'divider',
    backgroundColor: 'transparent',
  },
};

// Common flex container styles
export const flex = {
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  between: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  start: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  end: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
};
